export default [
  {
    name: 'Organizations',
    path: '/organizations',
    component: () => import('./pages/Organizations'),
    meta: {
      ability: [
        {
          resource: 'organizations',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Add Organization',
    path: '/organizations/add',
    component: () => import('./pages/OrganizationDetails'),
    meta: {
      ability: [
        {
          resource: 'organizations',
          actions: ['create'],
        },
      ],
    },
  },
  {
    name: 'Edit Organization',
    path: '/organizations/edit/:id',
    component: () => import('./pages/OrganizationDetails'),
    meta: {
      ability: [
        {
          resource: 'organizations/:id',
          actions: ['update'],
        },
      ],
    },
    props: {
      editMode: true,
    },
  },
]
